import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

const VAL_INDICADOR_COMPLETO = "999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE = 'cs_id_701';

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Activos fijos', listHelp: ['786'] }
];

const tableStructure = [
  { id: 'desc', title: 'Descripción' },
  { id: 'valVenta', title: 'Valor' }
];

class Form1 {
  id: number;
  desc: string;
  valCompra: string;
  valDeclaradoAnioAnterior: string;
  aplicoArt73: string;
  art: number;
  
  ////////  Nuevos
  valLimiteImpPagExt: string;
  valVenta: string
  valMejoras: string;
  valImpuestoPag: string;
  valImpuestoCol: string;
  valCostoFiscal: string;
  valNacional: number;
  valAplicoArt73: string;
}


class ArticulosDominio {
  valor: number;
  nombre: string;
}

@Component({
  selector: 'app-ganancias-ocasionales-activos-modal',
  templateUrl: './ganancias-ocasionales-activos-modal.component.html',
  styleUrls: ['./ganancias-ocasionales-activos-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class GananciasOcasionalesActivosModalComponent extends HandlerModal implements OnInit {

  
  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstArticulos: ArticulosDominio[] = [];
  public lstAnios: number[] = [];
  public lstSiNo: ArticulosDominio[] = [];

  public OPERACION_NULA: number = 0;
  public OPERACION_AGREGAR: number = 1;
  public OPERACION_EDITAR: number = 2;
  public OPERACION_BORRAR: number = 3;
  public operacionTabla: number = this.OPERACION_NULA;

  saveModel = new EventEmitter();
  public showSave: boolean;
  tablaArt73: any;

  constructor(
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    public dialogRef: MatDialogRef<GananciasOcasionalesActivosModalComponent>,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);

    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.validateShowSave();
    //this.reloadSelArticulos();
    this.initializeAnios();
    this.inicializarLista();
  }

  protected inicializeForm() {
    this.modelForm = new Form1();
    this.modelForm.id = 0;
    this.modelForm.desc = "";
    this.modelForm.valCompra = "0";
    this.modelForm.valDeclaradoAnioAnterior = "0";
    this.modelForm.valMejoras = "0";
    this.modelForm.valImpuestoPag= "0";
    this.modelForm.valImpuestoCol = "0";
    this.modelForm.valVenta = "0";
    this.modelForm.aplicoArt73 = "1";
    this.modelForm.art = 0;
    this.modelForm.valLimiteImpPagExt = "0";
    this.modelForm.valNacional = 1;
    this.reloadSelArticulos();
  }

  protected inicializeModelo() {

    if (this.model.doc.cuerpo.cc_id_224 == undefined) {
      this.cleanAllValues();

    } else {
      if (!this.inconsistenciaCampos()) {

        console.log("ERROR ESTRUCTURA TABLA GO Inmuebles los campos de la tabla no están correctos. Se resetean datos de toda la tabla ");
        let i: number = 0;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_224); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_354); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_353); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_356); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_361); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_357); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_355); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_359); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_360); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_225); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_362); i = i + 1;

        this.cleanAllValues();
        this.model.doc.cuerpo.cs_id_676= "0";
        this.model.doc.cuerpo.cs_id_787="0";	
			  this.model.doc.cuerpo.cs_id_789="0";

      }
    }
    //this.model.doc.cuerpo.cc_id_362 = "0";  //?*?* pendiente totalizar 

  }

  protected cleanAllValues() {
    this.model.doc.cuerpo.cs_id_676 = "0";
    this.model.doc.cuerpo.cs_id_787 = "0";
    this.model.doc.cuerpo.cs_id_789 = "0";
    this.model.doc.cuerpo.cc_id_224 = [];
    this.model.doc.cuerpo.cc_id_354 = [];
    this.model.doc.cuerpo.cc_id_353 = [];
    this.model.doc.cuerpo.cc_id_356 = [];
    this.model.doc.cuerpo.cc_id_361 = [];
    this.model.doc.cuerpo.cc_id_357 = [];
    this.model.doc.cuerpo.cc_id_355 = [];
    this.model.doc.cuerpo.cc_id_359 = [];
    this.model.doc.cuerpo.cc_id_360 = [];
    this.model.doc.cuerpo.cc_id_225 = [];
    this.model.doc.cuerpo.cc_id_362 = [];
    this.model.doc.cuerpo.cs_id_701 = "0";//Indicador de Completo

  }





  public inconsistenciaCampos(): boolean {
    const longitud224: number = this.model.doc.cuerpo.cc_id_224.length;
    return this.validarContenido(this.model.doc.cuerpo.cc_id_354, longitud224) ||
      this.validarContenido(this.model.doc.cuerpo.cc_id_353, longitud224) ||
      this.validarContenido(this.model.doc.cuerpo.cc_id_356, longitud224) ||
      this.validarContenido(this.model.doc.cuerpo.cc_id_361, longitud224) ||
      this.validarContenido(this.model.doc.cuerpo.cc_id_357, longitud224) ||
      this.validarContenido(this.model.doc.cuerpo.cc_id_355, longitud224) ||
      this.validarContenido(this.model.doc.cuerpo.cc_id_359, longitud224) ||
      this.validarContenido(this.model.doc.cuerpo.cc_id_360, longitud224) ||
      this.validarContenido(this.model.doc.cuerpo.cc_id_225, longitud224) ||
      this.validarContenido(this.model.doc.cuerpo.cc_id_362, longitud224);

  }

  protected validarContenido(casComp: string[], longitud: number) {
    return (casComp != undefined && casComp != null && casComp.length == longitud);

  }
  protected reloadSelArticulos(conservarArt?: boolean) {//Dom 1649

    this.lstArticulos[0] = { valor: 0, nombre: "" };
    this.lstArticulos[2] = { valor: 2, nombre: "Valor Compra" };
    this.lstArticulos[3] = { valor: 3, nombre: "Valor declarado año anterior" };

    this.lstArticulos = [];
    let i = 0;
    this.lstArticulos[i] = { valor: 0, nombre: "" };
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.modelForm.valCompra.toString(), "0")) {
      i++;
      this.lstArticulos[i] = { valor: 2, nombre: ("Valor de compra: $" + this.modelForm.valCompra) };
    }
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.modelForm.valDeclaradoAnioAnterior.toString(), "0")) {
      i++;
      this.lstArticulos[i] = { valor: 3, nombre: ("Valor declarado 2021: $" + this.modelForm.valDeclaradoAnioAnterior) };
    }
    
    if (!conservarArt) this.modelForm.art = 0;
  }

  protected initializeAnios(){
    for(let i=0; i<this.tablaArt73.length;i++){
      if( Number(this.tablaArt73[i].anio) != 2020 &&
      Number(this.tablaArt73[i].anio) != 2021 && Number(this.tablaArt73[i].anio) != 2022 
   ){
      this.lstAnios[i]=Number(this.tablaArt73[i].anio);
      }
    }
  }

  protected inicializarLista() {
   
     
      this.lstSiNo[0] = {valor:1,nombre:"Si"};
      this.lstSiNo[1] = {valor:0,nombre:"No"};
  
  }


  public operacionCs676() {
    let suma1 = "0";
    let suma2 = "0";
    let suma3 = "0";
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      suma1 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valVenta, suma1);
      suma2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valCostoFiscal, suma2);
      suma3 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valLimiteImpPagExt, suma3);
    

    }
    this.model.doc.cuerpo.cs_id_676 = suma1;   //valor total venta 
    this.model.doc.cuerpo.cs_id_787 = suma2;   //valor total fiscal 
    this.model.doc.cuerpo.cs_id_789 = suma3;   //valor total venta 
  }

  public operaciones(numCas?: number, soloEstaCasilla?: boolean): void {
    switch (numCas) {
      case 158:
        this.operacionCS158();
        break;

    }
    if (soloEstaCasilla) return;

    //Operaciones
    let resultado = "0";

    this.reloadSelArticulos();

  }

  operacionCS158() {
    this.model.doc.cuerpo.cs_id_158 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_158, true);
  }


  //////////////////////
 /**  protected initializeArticulos() {
    this.lstUbicaciones[0] = { valor: 1, nombre: "Nacional" };
    this.lstUbicaciones[1] = { valor: 2, nombre: "Extranjero" };
    this.lstSiNo[0] = { valor: 1, nombre: "Si" };
    this.lstSiNo[1] = { valor: 1, nombre: "No" };

  }*/ 




  public onChangeUbicacion(){
    if(this.modelForm.valNacional!=0){
      this.modelForm.valImpuestoPag = "0";
    }
  }
  //////////////////////

  protected initializeTablaDesdeModelo() {
    this.dataSourceBody = [];
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_224.length; i++) {
      this.modelForm.id = i;
      this.modelForm.desc = this.model.doc.cuerpo.cc_id_224[i].v;
      this.modelForm.valVenta = this.model.doc.cuerpo.cc_id_353[i].v;
      this.modelForm.valCompra = this.model.doc.cuerpo.cc_id_356[i].v;
      this.modelForm.valDeclaradoAnioAnterior = this.model.doc.cuerpo.cc_id_357[i].v;
      //this.modelForm.ubicacion=this.model.doc.cuerpo.cc_id_359[i].v;
      this.modelForm.valMejoras = this.model.doc.cuerpo.cc_id_361[i].v; //nuevo
      this.modelForm.valImpuestoPag = this.model.doc.cuerpo.cc_id_355[i].v;
      this.modelForm.valLimiteImpPagExt = this.model.doc.cuerpo.cc_id_362[i].v;
      this.modelForm.valCostoFiscal = this.model.doc.cuerpo.cc_id_360[i].v;
      this.modelForm.valImpuestoCol = this.model.doc.cuerpo.cc_id_225[i].v;
      this.modelForm.valNacional = this.model.doc.cuerpo.cc_id_354[i].v;
      this.modelForm.art = this.model.doc.cuerpo.cc_id_359[i].v;


      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }

  public editModeloDesdeForm() {
    this.model.doc.cuerpo.cc_id_224[this.modelForm.id].v = this.modelForm.desc;
    this.model.doc.cuerpo.cc_id_353[this.modelForm.id].v = this.modelForm.valVenta.toString();
    this.model.doc.cuerpo.cc_id_356[this.modelForm.id].v = this.modelForm.valCompra.toString();
    this.model.doc.cuerpo.cc_id_357[this.modelForm.id].v = this.modelForm.valDeclaradoAnioAnterior.toString();
    this.model.doc.cuerpo.cc_id_359[this.modelForm.id].v = this.modelForm.art.toString();
    this.model.doc.cuerpo.cc_id_361[this.modelForm.id].v = this.modelForm.valMejoras.toString();
    this.model.doc.cuerpo.cc_id_355[this.modelForm.id].v = this.modelForm.valImpuestoPag.toString();
    this.model.doc.cuerpo.cc_id_360[this.modelForm.id].v = this.modelForm.valCostoFiscal.toString();
    this.model.doc.cuerpo.cc_id_225[this.modelForm.id].v = this.modelForm.valImpuestoCol.toString();
    this.model.doc.cuerpo.cc_id_354[this.modelForm.id].v = this.modelForm.valNacional.toString();
    this.model.doc.cuerpo.cc_id_362[this.modelForm.id].v = this.modelForm.valLimiteImpPagExt.toString();



    //this.model.doc.cuerpo.cc_id_356[this.modelForm.id].v=this.modelForm.art.toString();
    //this.model.doc.cuerpo.cc_id_362[this.modelForm.id].v = this.dutilidades.deshacerFormatoMoneda(this.modelForm.valDeclarar);
  }

  public addToModeloDesdeForm() {
    let i = this.modelForm.id + 1;
    this.model.doc.cuerpo.cc_id_224.push({ it: i, v: this.modelForm.desc });
    this.model.doc.cuerpo.cc_id_353.push({ it: i, v: this.modelForm.valVenta.toString() });
    this.model.doc.cuerpo.cc_id_356.push({ it: i, v: this.modelForm.valCompra.toString() });
    this.model.doc.cuerpo.cc_id_357.push({ it: i, v: this.modelForm.valDeclaradoAnioAnterior.toString() });
    this.model.doc.cuerpo.cc_id_359.push({ it: i, v: this.modelForm.art.toString() });
    this.model.doc.cuerpo.cc_id_361.push({ it: i, v: this.modelForm.valMejoras.toString() });
    this.model.doc.cuerpo.cc_id_355.push({ it: i, v: this.modelForm.valImpuestoPag.toString() });
    this.model.doc.cuerpo.cc_id_360.push({ it: i, v: this.modelForm.valCostoFiscal.toString() });
    this.model.doc.cuerpo.cc_id_225.push({ it: i, v: this.modelForm.valImpuestoCol.toString() });
    this.model.doc.cuerpo.cc_id_354.push({ it: i, v: this.modelForm.valNacional });
    this.model.doc.cuerpo.cc_id_362.push({ it: i, v: this.modelForm.valLimiteImpPagExt.toString() });


    //this.model.doc.cuerpo.cc_id_356.push({it: i, v:this.modelForm.art.toString()});
    //this.model.doc.cuerpo.cc_id_362.push({ it: i, v: this.dutilidades.deshacerFormatoMoneda(this.modelForm.valDeclarar) });
  }

  public deleteOnModel(index: number) {
    this.model.doc.cuerpo.cc_id_224.splice(index, 1);
    this.model.doc.cuerpo.cc_id_353.splice(index, 1);
    this.model.doc.cuerpo.cc_id_356.splice(index, 1);
    this.model.doc.cuerpo.cc_id_357.splice(index, 1);
    this.model.doc.cuerpo.cc_id_359.splice(index, 1);
    this.model.doc.cuerpo.cc_id_361.splice(index, 1);
    this.model.doc.cuerpo.cc_id_355.splice(index, 1);
    this.model.doc.cuerpo.cc_id_362.splice(index, 1);
    this.model.doc.cuerpo.cc_id_360.splice(index, 1);
    this.model.doc.cuerpo.cc_id_225.splice(index, 1);
    this.model.doc.cuerpo.cc_id_354.splice(index, 1);



    //reenumerear it
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_224.length; i++) {
      this.model.doc.cuerpo.cc_id_224[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_353[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_357[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_359[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_361[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_355[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_356[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_362[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_354[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_360[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_225[i].it = i + 1;

    }
  }

  public validateFormCompleted(): boolean {

    console.log('Valores Formulario detalle: desc: ' + this.modelForm.desc + ' valVenta: ' + this.modelForm.valVenta +
      ' valCompra: ' + this.modelForm.valCompra +
      ' valDeclaradoAnioAnterior: ' + this.modelForm.valDeclaradoAnioAnterior + ' valAvaluo : '
    );



    return this.modelForm.desc == undefined || this.modelForm.desc == "" ||
      this.modelForm.valVenta == undefined || this.modelForm.valVenta == "0" ||
      this.modelForm.valCompra == undefined || this.modelForm.valCompra == "0" ||
      this.modelForm.valVenta == undefined || this.modelForm.valVenta == "0" ||
      this.modelForm.valDeclaradoAnioAnterior == undefined || this.modelForm.valDeclaradoAnioAnterior == "0"||
      //this.modelForm.ubicacion == undefined || this.modelForm.ubicacion == "0" ||
      Number(this.modelForm.art) == undefined || Number(this.modelForm.art) == 0 
      //this.modelForm.valMejoras ==undefined || this.modelForm.valMejoras == "0"  //||
      //this.modelForm.valImpuestoPag ==undefined || this.modelForm.valImpuestoPag ==0  //||
      //this.modelForm.valDeclarar==undefined || this.modelForm.valDeclarar==""
      ;
  }

   public redondearFormData() {
    this.modelForm.valCompra=this.dutilidades.redondearValorMoneda(this.modelForm.valCompra.toString(),true);
    this.modelForm.valDeclaradoAnioAnterior=this.dutilidades.redondearValorMoneda(this.modelForm.valDeclaradoAnioAnterior.toString(),true);
    this.modelForm.valVenta=this.dutilidades.redondearValorMoneda(this.modelForm.valVenta.toString(),true);
    this.modelForm.valImpuestoPag =this.dutilidades.redondearValorMoneda(this.modelForm.valImpuestoPag.toString(),true);
    this.modelForm.valMejoras =this.dutilidades.redondearValorMoneda(this.modelForm.valMejoras.toString(),true);
    this.modelForm.valLimiteImpPagExt =this.dutilidades.redondearValorMoneda(this.modelForm.valLimiteImpPagExt.toString(),true);
   
   }

   //limite impuesto pagado en colombia
OperacionCsLimiteImp(valImp:string,valVenta:string,costoFiscal:string){
	 valImp = this.dutilidades.redondearValorMoneda(valImp);	
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,valImp,"0")) {
		
		//const cas353 = this.model.doc.cuerpo.cs_id_353; //valVenta
		//const cas360 = this.model.doc.cuerpo.cs_id_360; //costoFiscal
		
		let resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA,valVenta,costoFiscal);
		if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,resultado,"0")) {
			resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,resultado,"0.1");
			this.modelForm.valImpuestoCol = resultado;
			if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,valImp,resultado)) {
				this.modelForm.valLimiteImpPagExt = resultado;
			} else {
				this.modelForm.valLimiteImpPagExt= valImp;
			}			
		} else {
      this.modelForm.valLimiteImpPagExt = "0";
      this.modelForm.valImpuestoCol = "0";
		}
	}
}

   public calcularValoresForm(conservarArt?:boolean){
    this.redondearFormData();
    if(this.modelForm.valNacional== 1){
      this.modelForm.valImpuestoCol = "0";
      this.modelForm.valImpuestoPag = "0";
      this.modelForm.valLimiteImpPagExt = "0";
    }
    let valDeclarar = "0";
    switch(Number(this.modelForm.art)){
      case 2:
        valDeclarar = this.modelForm.valCompra.toString();
        break;
      case 3:
        valDeclarar = this.modelForm.valDeclaradoAnioAnterior.toString();
        break;
      default:
        valDeclarar = "0";      
    }
    
    this.modelForm.valCostoFiscal =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.modelForm.valMejoras.toString(),valDeclarar  ,false);
    this.modelForm.valCostoFiscal = this.dutilidades.redondearValorMoneda(this.modelForm.valCostoFiscal.toString(),true);
   
   
    if (this.modelForm.valNacional == 0){ //Calcula limite de Immp
      this.OperacionCsLimiteImp(this.modelForm.valImpuestoPag,this.modelForm.valVenta,this.modelForm.valCostoFiscal)
    }
    
    this.reloadSelArticulos(conservarArt);
  }
  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
      if (this.operacionTabla==this.OPERACION_EDITAR){
        this.editModeloDesdeForm();
      }else if (this.operacionTabla==this.OPERACION_AGREGAR){
        this.modelForm.id = this.dataSourceBody.length;
        this.dataSourceBody.push(this.modelForm);
        this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs676();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
      console.log(this.model);
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs676();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
      this.reloadSelArticulos(true);
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
      console.log(this.model);
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }

  
  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO
  public validateRbQuestions(val: string) {
    this.modelForm.aplicoArt73 = val;
    this.calcularValoresForm();
  }
  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){

  }

  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }


  protected controlStep(direction: DirectionType): void {
    this.changeStepLocal(this.indexStepper, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?:boolean){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(forceUpdateStepper){
      this.changeStep(index);
      this.updateIndicadorAvance();
    }else if(this.validateStepHabilitado(index)){
      let indexCalc = index-1;
      if(indexCalc<=Number(casIndicadorAvance)){
        this.changeStep(index);
        this.updateIndicadorAvance();
      }else{
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1="+(indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }
  
  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }

  public closeModal(){
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }
  public guardar(){
    this.saveModel.emit(true);
    if(this.indexStepper==this.stepsList.length-1){
      this.closeModal();
    }
  }
  public borrarTabla(){
    this.dataSourceBody = [];
  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/ganancias-ocasionales/ganancias-ocasionales-activos-modal/ganancias-ocasionales-activos-modal.component.ts